import { jsxs, jsx } from 'react/jsx-runtime';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import '../ui/badge.js';
import { MapPin } from 'lucide-react';
import 'react';
import 'react-day-picker';
import '../ui/button.js';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '../ui/time-input.js';
import '@radix-ui/react-separator';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../page-layout/FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

function MapPreview({ latitude, longitude, googleMapsApiKey, alt = 'Map preview', zoom = 15, height = 'h-40', className, fallbackText = 'No coordinates available', }) {
    const hasCoords = latitude != null && longitude != null;
    if (!hasCoords || !googleMapsApiKey) {
        return (jsxs("div", { className: cn('rounded-lg bg-muted/50 flex flex-col items-center justify-center text-muted-foreground', height, className), children: [jsx(MapPin, { className: "h-6 w-6 mb-1" }), jsx("span", { className: "text-sm", children: fallbackText })] }));
    }
    const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=${zoom}&size=600x300&scale=2&maptype=roadmap&markers=color:red%7C${latitude},${longitude}&key=${googleMapsApiKey}`;
    const mapsLink = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
    return (jsx("a", { href: mapsLink, target: "_blank", rel: "noopener noreferrer", className: cn('block rounded-lg overflow-hidden', height, className), children: jsx("img", { src: staticMapUrl, alt: alt, className: "w-full h-full object-cover" }) }));
}

export { MapPreview };
//# sourceMappingURL=MapPreview.js.map
